import { type FireAnalyticsEvent } from '../../types';

export const onRecommendationsDegraded = ({
	searchSessionId,
	reason,
}: {
	searchSessionId?: string;
	reason: 'timeout' | 'failure';
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: 'searchPage',
	action: '3pRecommendationStatus',
	attributes: {
		additionalAttributes: {
			status: 'DEGRADED',
			searchSessionId,
			reason,
		},
	},
});
